import {
  Plane, Users, GraduationCap, Briefcase, HeartHandshake, Award, Zap, MapPin, Building2, Home, Flag, ShieldAlert, Landmark,
} from "lucide-react";

const MAP = { Plane, Users, GraduationCap, Briefcase, HeartHandshake, Award, Zap, MapPin, Building2, Home, Flag, ShieldAlert, Landmark };

export const ServiceIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = MAP[name] || Landmark;
  return <Icon className={className} strokeWidth={1.75} aria-hidden="true" />;
};
